import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { fetchCCFEntries } from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchCCFEntries.started, state => ({
        ...state,
    }))
    .case(fetchCCFEntries.done, (state, { result: { tabs } }) => ({
        ...state,
        tabs:
            tabs?.map(tab => ({
                ...tab,
                elements: tab.elements.filter(element => element.type === 'category') || [],
            })) || [],
    }))
    .case(fetchCCFEntries.failed, (state, { error }) => ({
        ...state,
        tabs: [],
        error,
    }));

export default reducer;
